// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.
import { BASE_POPUP, showModal } from '@shared/ui-kit/components/popups/show-modal';
import { formatToMoney } from './format-to-money';
import { AppIcon } from '@shared/ui-kit/components/app-icon';
import type { TFunction } from 'i18next';

export const alertInsufficientCash = (debt: number, t: TFunction) => {
  const message = (
    <>
      {t('research.insufficient-cash.message', { ns: 'research' })}
      <br />
      <br />
      {t('research.insufficient-cash.instruction', { ns: 'research' })}
      &nbsp;<strong>{formatToMoney(debt)}</strong>
    </>
  );
  /* istanbul ignore next */
  return showModal({
    ...BASE_POPUP,
    icon: <AppIcon icon="ExclamationMark" color="main" />,
    variant: 'overflow',
    buttons: {
      cancel: {
        show: true,
        text: t('common.cancel', { ns: 'common' }),
      },
      confirm: {
        show: true,
        text: t('common.reload', { ns: 'common' }),
      },
    },
    content: message,
    width: 400,
    title: t('research.insufficient-cash.title', { ns: 'research' }),
  });
};
